import { types } from "mobx-state-tree"

export const Note = types
    .model("Note", {
        title: types.string,
        body: types.maybe(types.string),
        visible_to_owner: types.maybe(types.boolean)
    })